export default class Hero {
  constructor() {
    this.hero = document.querySelector('[data-hero]');
    if (!this.hero) return;
    this.bgImg = document.querySelector('[data-hero-el="bg-img"]');
    this.line = [...document.querySelectorAll('[data-hero-el="bg-line"]')]
    this.particles = [...document.querySelectorAll('[data-hero-el="particles"]')]
    this.screenshot01 = document.querySelector('[data-hero-el="screenshot1"]');
    this.screenshot02 = document.querySelector('[data-hero-el="screenshot2"]');
    this.men = document.querySelector('[data-hero-el="men"]');
    this.women01 = document.querySelector('[data-hero-el="women1"]');
    this.women02 = document.querySelector('[data-hero-el="women2"]');
    this.points = [...document.querySelectorAll('[data-hero-el="point"]')]
    this.setup();
    this.init();
  }

  setup() {
    gsap.set([this.particles, this.line], { autoAlpha: 0 })
    gsap.set([this.screenshot01, this.screenshot02], { autoAlpha: 0, x: 100, y: -100 })
    gsap.set([this.men, this.women01, this.women02], { autoAlpha: 0, yPercent: -20 })
    gsap.set(this.points, { autoAlpha: 0, yPercent: 50 })
  }

  init() {
    window.addEventListener('load', () => {
      setTimeout(() => this.opening(), 500);
    });
  }

  opening() {
    const openingTl = gsap.timeline({ defaults: { duration: 0.8, ease: 'circ.out' }});
    openingTl
      .to(this.screenshot02, {
        autoAlpha: 1,
        x: 0,
        y: 0,
      })
      .to(this.screenshot01, {
        autoAlpha: 1,
        x: 0,
        y: 0,
      }, '<0.2')
      .to([this.men, this.women01, this.women02], {
        autoAlpha: 1,
        yPercent: 0,
        ease: 'expo.out',
        stagger: 0.2,
      }, '<0.4')
      .to(this.points, {
        autoAlpha: 1,
        yPercent: 0,
        stagger: 0.1,
      }, '<0.6')
      .to([this.particles, this.line], {
        autoAlpha: 1,
        duration: 0.5,
        ease: 'none',
      })
  }
}
